module.exports = __webpack_public_path__ + "static/media/img-modal-first-bulletin.9f79c9b9.svg";